import { ChangeDetectionStrategy, Component, input, model, output } from "@angular/core";
import { IWizardStepChangedEvent, ModuleTabConfig } from "@kiraah-shared/core";
import { TranslateModule } from "@ngx-translate/core";
import { MobileWizardNavigationComponent } from "../mobile-wizard-navigation/mobile-wizard-navigation.component";
import type { MobileWizardStepMeta } from "../helpers/mobile-ticket-wizard-steps.model";

@Component({
  selector: "mobile-module-tab",
  standalone: true,
  imports: [TranslateModule, MobileWizardNavigationComponent],
  templateUrl: "./mobile-module-tab.component.html",
  styleUrl: "./mobile-module-tab.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileModuleTabComponent {
  readonly config = input<ModuleTabConfig | undefined>(undefined);
  readonly steps = input<readonly MobileWizardStepMeta[] | undefined>(undefined);
  readonly activeIndex = model(0);
  readonly showCloseButton = input(true);
  readonly showWizardNavigation = input(false);

  readonly wizardInstanceId = input<string | null | undefined>(undefined);
  readonly isNavigating = input(false);
  readonly showSaveAsDraft = input(false);
  readonly isSaving = input(false);
  readonly allowSubmit = input(true);
  readonly allowSaveAsDraft = input(true);

  readonly closeRequested = output<void>();
  readonly wizardPrevious = output<void>();
  readonly wizardNext = output<void>();
  readonly wizardSaveAsDraft = output<void>();
  readonly wizardSubmit = output<void>();
  readonly wizardStepChanged = output<IWizardStepChangedEvent>();

  onCloseClick(): void {
    this.closeRequested.emit();
  }
}
